export default {
  computed: {
    navigation() {
      return this.$router.options.routes.filter((item) => item.meta?.navigation);
    },
    routes() {
      return this.$router.options.routes;
    },
  },
  methods: {
    getRouteName(route) {
      return route.meta?.name || route.name;
    },
  },
};
